<template>
  <div>
    <v-btn @click="add">Add New Property</v-btn>
    <span v-if="errorMessages">{{ errorMessages }}</span>
    <div
      v-for="(key, index) in Object.keys(properties)"
      :key="`rootProp-${index}`"
    >
      <v-row>
        <v-col md="4" cols="12">
          <v-text-field
            label="Property Name"
            :value="key"
            @input="onPropKeyChanged($event, key, index)"
          ></v-text-field>
        </v-col>
        <v-col md="3" cols="12">
          <v-autocomplete
            v-model="properties[key].type"
            label="Property Type"
            :items="['integer', 'string']"
            filled
          ></v-autocomplete>
        </v-col>
        <v-col md="3" cols="12">
          <v-text-field
            label="Property Title"
            v-model="properties[key].title"
          ></v-text-field>
        </v-col>
        <v-col md="2" cols="12">
          <v-btn @click="delKey(key)">Delete</v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: '{"type": "object", "properties": {}}'
    },
    errorMessages: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      properties: {}
    };
  },
  watch: {
    value: {
      handler: function(newVal) {
        let incomingVal = JSON.parse(newVal);
        this.properties = incomingVal.properties;
      },
      immediate: true
    },
    properties: {
      handler: function() {
        let outgoingVal = {
          type: "object",
          properties: { ...this.properties }
        };
        this.$emit("input", JSON.stringify(outgoingVal));
      },
      deep: true
    }
  },
  methods: {
    add() {
      let newPropName = `newPropName${Object.keys(this.properties).length + 1}`;
      this.$set(this.properties, newPropName, {});
    },
    delKey(key) {
      this.$delete(this.properties, key);
    },
    onPropKeyChanged(newKey, oldKey, index) {
      let newProperties = {};
      for (const [i, key] of Object.keys(this.properties).entries()) {
        if (i !== index) {
          newProperties[key] = { ...this.properties[key] };
        } else {
          newProperties[newKey] = {
            ...this.properties[oldKey]
          };
        }
      }
      this.properties = newProperties;
    }
  }
};
</script>
